/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as LoginRouteImport } from './login'
import { Route as IndexRouteImport } from './index'
import { Route as TenantsIndexRouteImport } from './tenants/index'
import { Route as AdminUsersRouteImport } from './admin/users'
import { Route as AdminSystemRouteImport } from './admin/system'
import { Route as AdminIngestRouteImport } from './admin/ingest'
import { Route as AdminAuditLogRouteImport } from './admin/audit-log'
import { Route as TenantsSlugIndexRouteImport } from './tenants/$slug/index'
import { Route as TenantsSlugSourcesRouteImport } from './tenants/$slug/sources'
import { Route as TenantsSlugSettingsRouteImport } from './tenants/$slug/settings'
import { Route as TenantsSlugRecipientsRouteImport } from './tenants/$slug/recipients'
import { Route as TenantsSlugDeliveriesRouteImport } from './tenants/$slug/deliveries'
import { Route as TenantsSlugAlertsRouteImport } from './tenants/$slug/alerts'
import { Route as TenantsSlugReportsIndexRouteImport } from './tenants/$slug/reports/index'
import { Route as TenantsSlugDomainsIndexRouteImport } from './tenants/$slug/domains/index'
import { Route as TenantsSlugReportsIdRouteImport } from './tenants/$slug/reports/$id'
import { Route as TenantsSlugDomainsIdRouteImport } from './tenants/$slug/domains/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsIndexRoute = TenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSystemRoute = AdminSystemRouteImport.update({
  id: '/admin/system',
  path: '/admin/system',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIngestRoute = AdminIngestRouteImport.update({
  id: '/admin/ingest',
  path: '/admin/ingest',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugIndexRoute = TenantsSlugIndexRouteImport.update({
  id: '/tenants/$slug/',
  path: '/tenants/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugSourcesRoute = TenantsSlugSourcesRouteImport.update({
  id: '/tenants/$slug/sources',
  path: '/tenants/$slug/sources',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugSettingsRoute = TenantsSlugSettingsRouteImport.update({
  id: '/tenants/$slug/settings',
  path: '/tenants/$slug/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugRecipientsRoute = TenantsSlugRecipientsRouteImport.update({
  id: '/tenants/$slug/recipients',
  path: '/tenants/$slug/recipients',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugDeliveriesRoute = TenantsSlugDeliveriesRouteImport.update({
  id: '/tenants/$slug/deliveries',
  path: '/tenants/$slug/deliveries',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugAlertsRoute = TenantsSlugAlertsRouteImport.update({
  id: '/tenants/$slug/alerts',
  path: '/tenants/$slug/alerts',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugReportsIndexRoute = TenantsSlugReportsIndexRouteImport.update({
  id: '/tenants/$slug/reports/',
  path: '/tenants/$slug/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugDomainsIndexRoute = TenantsSlugDomainsIndexRouteImport.update({
  id: '/tenants/$slug/domains/',
  path: '/tenants/$slug/domains/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugReportsIdRoute = TenantsSlugReportsIdRouteImport.update({
  id: '/tenants/$slug/reports/$id',
  path: '/tenants/$slug/reports/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantsSlugDomainsIdRoute = TenantsSlugDomainsIdRouteImport.update({
  id: '/tenants/$slug/domains/$id',
  path: '/tenants/$slug/domains/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/tenants/': typeof TenantsIndexRoute
  '/tenants/$slug/alerts': typeof TenantsSlugAlertsRoute
  '/tenants/$slug/deliveries': typeof TenantsSlugDeliveriesRoute
  '/tenants/$slug/recipients': typeof TenantsSlugRecipientsRoute
  '/tenants/$slug/settings': typeof TenantsSlugSettingsRoute
  '/tenants/$slug/sources': typeof TenantsSlugSourcesRoute
  '/tenants/$slug/': typeof TenantsSlugIndexRoute
  '/tenants/$slug/domains/$id': typeof TenantsSlugDomainsIdRoute
  '/tenants/$slug/reports/$id': typeof TenantsSlugReportsIdRoute
  '/tenants/$slug/domains/': typeof TenantsSlugDomainsIndexRoute
  '/tenants/$slug/reports/': typeof TenantsSlugReportsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/tenants': typeof TenantsIndexRoute
  '/tenants/$slug/alerts': typeof TenantsSlugAlertsRoute
  '/tenants/$slug/deliveries': typeof TenantsSlugDeliveriesRoute
  '/tenants/$slug/recipients': typeof TenantsSlugRecipientsRoute
  '/tenants/$slug/settings': typeof TenantsSlugSettingsRoute
  '/tenants/$slug/sources': typeof TenantsSlugSourcesRoute
  '/tenants/$slug': typeof TenantsSlugIndexRoute
  '/tenants/$slug/domains/$id': typeof TenantsSlugDomainsIdRoute
  '/tenants/$slug/reports/$id': typeof TenantsSlugReportsIdRoute
  '/tenants/$slug/domains': typeof TenantsSlugDomainsIndexRoute
  '/tenants/$slug/reports': typeof TenantsSlugReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/ingest': typeof AdminIngestRoute
  '/admin/system': typeof AdminSystemRoute
  '/admin/users': typeof AdminUsersRoute
  '/tenants/': typeof TenantsIndexRoute
  '/tenants/$slug/alerts': typeof TenantsSlugAlertsRoute
  '/tenants/$slug/deliveries': typeof TenantsSlugDeliveriesRoute
  '/tenants/$slug/recipients': typeof TenantsSlugRecipientsRoute
  '/tenants/$slug/settings': typeof TenantsSlugSettingsRoute
  '/tenants/$slug/sources': typeof TenantsSlugSourcesRoute
  '/tenants/$slug/': typeof TenantsSlugIndexRoute
  '/tenants/$slug/domains/$id': typeof TenantsSlugDomainsIdRoute
  '/tenants/$slug/reports/$id': typeof TenantsSlugReportsIdRoute
  '/tenants/$slug/domains/': typeof TenantsSlugDomainsIndexRoute
  '/tenants/$slug/reports/': typeof TenantsSlugReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin/audit-log'
    | '/admin/ingest'
    | '/admin/system'
    | '/admin/users'
    | '/tenants/'
    | '/tenants/$slug/alerts'
    | '/tenants/$slug/deliveries'
    | '/tenants/$slug/recipients'
    | '/tenants/$slug/settings'
    | '/tenants/$slug/sources'
    | '/tenants/$slug/'
    | '/tenants/$slug/domains/$id'
    | '/tenants/$slug/reports/$id'
    | '/tenants/$slug/domains/'
    | '/tenants/$slug/reports/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin/audit-log'
    | '/admin/ingest'
    | '/admin/system'
    | '/admin/users'
    | '/tenants'
    | '/tenants/$slug/alerts'
    | '/tenants/$slug/deliveries'
    | '/tenants/$slug/recipients'
    | '/tenants/$slug/settings'
    | '/tenants/$slug/sources'
    | '/tenants/$slug'
    | '/tenants/$slug/domains/$id'
    | '/tenants/$slug/reports/$id'
    | '/tenants/$slug/domains'
    | '/tenants/$slug/reports'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/admin/audit-log'
    | '/admin/ingest'
    | '/admin/system'
    | '/admin/users'
    | '/tenants/'
    | '/tenants/$slug/alerts'
    | '/tenants/$slug/deliveries'
    | '/tenants/$slug/recipients'
    | '/tenants/$slug/settings'
    | '/tenants/$slug/sources'
    | '/tenants/$slug/'
    | '/tenants/$slug/domains/$id'
    | '/tenants/$slug/reports/$id'
    | '/tenants/$slug/domains/'
    | '/tenants/$slug/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminIngestRoute: typeof AdminIngestRoute
  AdminSystemRoute: typeof AdminSystemRoute
  AdminUsersRoute: typeof AdminUsersRoute
  TenantsIndexRoute: typeof TenantsIndexRoute
  TenantsSlugAlertsRoute: typeof TenantsSlugAlertsRoute
  TenantsSlugDeliveriesRoute: typeof TenantsSlugDeliveriesRoute
  TenantsSlugRecipientsRoute: typeof TenantsSlugRecipientsRoute
  TenantsSlugSettingsRoute: typeof TenantsSlugSettingsRoute
  TenantsSlugSourcesRoute: typeof TenantsSlugSourcesRoute
  TenantsSlugIndexRoute: typeof TenantsSlugIndexRoute
  TenantsSlugDomainsIdRoute: typeof TenantsSlugDomainsIdRoute
  TenantsSlugReportsIdRoute: typeof TenantsSlugReportsIdRoute
  TenantsSlugDomainsIndexRoute: typeof TenantsSlugDomainsIndexRoute
  TenantsSlugReportsIndexRoute: typeof TenantsSlugReportsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/': {
      id: '/tenants/'
      path: '/tenants'
      fullPath: '/tenants/'
      preLoaderRoute: typeof TenantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/system': {
      id: '/admin/system'
      path: '/admin/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AdminSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ingest': {
      id: '/admin/ingest'
      path: '/admin/ingest'
      fullPath: '/admin/ingest'
      preLoaderRoute: typeof AdminIngestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/': {
      id: '/tenants/$slug/'
      path: '/tenants/$slug'
      fullPath: '/tenants/$slug/'
      preLoaderRoute: typeof TenantsSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/sources': {
      id: '/tenants/$slug/sources'
      path: '/tenants/$slug/sources'
      fullPath: '/tenants/$slug/sources'
      preLoaderRoute: typeof TenantsSlugSourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/settings': {
      id: '/tenants/$slug/settings'
      path: '/tenants/$slug/settings'
      fullPath: '/tenants/$slug/settings'
      preLoaderRoute: typeof TenantsSlugSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/recipients': {
      id: '/tenants/$slug/recipients'
      path: '/tenants/$slug/recipients'
      fullPath: '/tenants/$slug/recipients'
      preLoaderRoute: typeof TenantsSlugRecipientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/deliveries': {
      id: '/tenants/$slug/deliveries'
      path: '/tenants/$slug/deliveries'
      fullPath: '/tenants/$slug/deliveries'
      preLoaderRoute: typeof TenantsSlugDeliveriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/alerts': {
      id: '/tenants/$slug/alerts'
      path: '/tenants/$slug/alerts'
      fullPath: '/tenants/$slug/alerts'
      preLoaderRoute: typeof TenantsSlugAlertsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/reports/': {
      id: '/tenants/$slug/reports/'
      path: '/tenants/$slug/reports'
      fullPath: '/tenants/$slug/reports/'
      preLoaderRoute: typeof TenantsSlugReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/domains/': {
      id: '/tenants/$slug/domains/'
      path: '/tenants/$slug/domains'
      fullPath: '/tenants/$slug/domains/'
      preLoaderRoute: typeof TenantsSlugDomainsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/reports/$id': {
      id: '/tenants/$slug/reports/$id'
      path: '/tenants/$slug/reports/$id'
      fullPath: '/tenants/$slug/reports/$id'
      preLoaderRoute: typeof TenantsSlugReportsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenants/$slug/domains/$id': {
      id: '/tenants/$slug/domains/$id'
      path: '/tenants/$slug/domains/$id'
      fullPath: '/tenants/$slug/domains/$id'
      preLoaderRoute: typeof TenantsSlugDomainsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminIngestRoute: AdminIngestRoute,
  AdminSystemRoute: AdminSystemRoute,
  AdminUsersRoute: AdminUsersRoute,
  TenantsIndexRoute: TenantsIndexRoute,
  TenantsSlugAlertsRoute: TenantsSlugAlertsRoute,
  TenantsSlugDeliveriesRoute: TenantsSlugDeliveriesRoute,
  TenantsSlugRecipientsRoute: TenantsSlugRecipientsRoute,
  TenantsSlugSettingsRoute: TenantsSlugSettingsRoute,
  TenantsSlugSourcesRoute: TenantsSlugSourcesRoute,
  TenantsSlugIndexRoute: TenantsSlugIndexRoute,
  TenantsSlugDomainsIdRoute: TenantsSlugDomainsIdRoute,
  TenantsSlugReportsIdRoute: TenantsSlugReportsIdRoute,
  TenantsSlugDomainsIndexRoute: TenantsSlugDomainsIndexRoute,
  TenantsSlugReportsIndexRoute: TenantsSlugReportsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
